import { render, staticRenderFns } from "./weifa.vue?vue&type=template&id=d168fa62"
import script from "./weifa.vue?vue&type=script&lang=ts"
export * from "./weifa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports